import { render, staticRenderFns } from "./AppSideBar.vue?vue&type=template&id=05d49e94"
import script from "./AppSideBar.vue?vue&type=script&lang=js"
export * from "./AppSideBar.vue?vue&type=script&lang=js"
import style0 from "./AppSideBar.vue?vue&type=style&index=0&id=05d49e94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../AppData/Roaming/nvm/v12.14.1/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports